import { render, staticRenderFns } from "./CustomRecipientItem.vue?vue&type=template&id=6d6aac14&scoped=true&"
import script from "./CustomRecipientItem.vue?vue&type=script&lang=ts&"
export * from "./CustomRecipientItem.vue?vue&type=script&lang=ts&"
import style0 from "./CustomRecipientItem.vue?vue&type=style&index=0&id=6d6aac14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6aac14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VDivider,VIcon,VMenu,VSpacer,VTextField})
